import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { setSelectedFunctionalAreas } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import PreferredEmailBanner from "components/common/PreferredEmailBanner";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import AssignMultiplePlansDialog from "components/common/plans/AssignMultiplePlansDialog";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { abovePropertyAssign, accessTypes } from "utils/CommonConstants";
import { getLoggedInUserDetails } from "utils/CommonFunctions";
import { clearChildFilters, clearFilter, setSearchText } from "./AboveProperty.slice";
import BookmarkedPlans from "./BookmarkedPlans";
import BookmarkedProperties from "./BookmarkedProperties";
import PlanView from "./PlanView";
import PropertyView from "./PropertyView";

interface Props {}

const AboveProperty = (props: Props) => {
  const translate = useTranslate();
  const [currTab, setCurrTab] = useState(0);
  const { isMobileScreen } = useContext(ThemeContext);
  const dispatch = useAppDispatch();
  const loggedInUserDetails = getLoggedInUserDetails();
  const [multiplansAssign, setMultiplansAssign] = useState(false);
  const isAbovePropertyUser = useAppSelector((state) => state.app.isAbovePropertyUser);

  const tabDetails = [
    { label: translate("dashboard.hotelView"), content: PropertyView },
    { label: translate("dashboard.planView"), content: PlanView }
  ];
  const handleCloseDialog = () => {
    setMultiplansAssign(false);
  };

  useEffect(() => {
    dispatch(clearChildFilters());
  }, []);

  return (
    <Stack direction={isMobileScreen ? "column" : "row"}>
      <Stack sx={{ flex: 1, pr: isMobileScreen ? 0 : "24px", overflowX: "auto" }}>
        <Grid display="flex" justifyContent={"space-between"} flexDirection={isMobileScreen ? "column" : "row"}>
          {" "}
          <Typography
            variant="h4"
            showBold
            textAlign={"center"}
            color={tokens.Text.General.PrimaryHeadline}
            sx={{
              paddingY: isMobileScreen ? "12px" : "24px"
            }}
          >
            {translate("dashboard.heading")}
          </Typography>
          {isAbovePropertyUser && (
            <Button
              label="Assign Plan"
              sx={{ marginTop: "12px" }}
              accessType={accessTypes.assign}
              onClick={() => {
                dispatch(clearFilter({ parentView: "dialogFilters", filterType: "planAssignment" }));
                dispatch(
                  setSearchText({
                    inputText: "",
                    searchType: "planAssignment",
                    filterName: "searchText",
                    parentView: "dialogFilters"
                  })
                );
                dispatch(setSelectedFunctionalAreas([]));
                setMultiplansAssign(true);
              }}
            />
          )}
        </Grid>
        {loggedInUserDetails &&
          Object.keys(loggedInUserDetails).length !== 0 &&
          !loggedInUserDetails?.preferredEmail && <PreferredEmailBanner />}
        <Basictabs
          sx={{ width: "100%", maxHeight: "calc(100vh - 240px)", overflow: "auto" }}
          labelVariant="h5"
          tabDetails={tabDetails}
          isParentTab
          alignItems="left"
          getCurrentTab={(val: any) => setCurrTab(val)}
          divId={isMobileScreen ? "div" : "tableDiv"}
        />
      </Stack>
      {!isMobileScreen && (
        <Stack
          id="bookmarkListContainer"
          sx={{
            backgroundColor: tokens.Background.General.Primary,
            maxWidth: "370px",
            width: "100%",
            height: "calc(100vh - 78px)",
            padding: "24px 16px",
            overflowY: "auto"
          }}
        >
          {tabDetails[currTab].label === "Plan View" ? <BookmarkedPlans /> : <BookmarkedProperties />}
        </Stack>
      )}
      {multiplansAssign && (
        <AssignMultiplePlansDialog
          setOpenAssignPlanDialog={setMultiplansAssign}
          handleCloseDialog={handleCloseDialog}
          // selectedPlanDetail={selectedPlanDetail}
          flowSpecificPayload={{ isBulkAssignment: true, innCode: "CORP", parent: "dashboard" }}
          assignType={abovePropertyAssign.multiple}
        />
      )}
    </Stack>
  );
};

export default AboveProperty;
